import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";
import { toast } from "sonner";

export const PWAInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const onBeforeInstall = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    const onInstalled = () => {
      setDeferredPrompt(null);
      toast.success("Aplikasi PT. Luminara Global Persada berhasil dipasang di perangkat Anda.");
    };
    window.addEventListener("beforeinstallprompt", onBeforeInstall);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onBeforeInstall);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (!deferredPrompt || dismissed) return null;

  const handleInstall = async () => {
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === "accepted") setDeferredPrompt(null);
  };

  return (
    <div
      data-testid="pwa-install-banner"
      className="fixed bottom-5 right-5 z-50 flex items-center gap-3 bg-navy-900 border border-gold/40 shadow-2xl px-5 py-4 max-w-xs"
    >
      <img src="/assets/logo-mark-gold.png" alt="Logo PT. Luminara Global Persada" className="w-9 h-9 object-contain shrink-0" />
      <div className="leading-tight">
        <p className="text-sm font-heading font-semibold text-white">Pasang Aplikasi</p>
        <p className="text-xs text-slate-400 mt-0.5">Akses lebih cepat dari layar utama HP Anda.</p>
      </div>
      <button
        data-testid="pwa-install-button"
        onClick={handleInstall}
        className="shrink-0 w-9 h-9 bg-gold text-navy-950 flex items-center justify-center hover:bg-gold-light transition-colors duration-300"
        aria-label="Pasang aplikasi ke layar utama"
      >
        <Download size={16} />
      </button>
      <button
        data-testid="pwa-install-dismiss"
        onClick={() => setDismissed(true)}
        className="absolute -top-2.5 -left-2.5 w-6 h-6 bg-navy-800 border border-white/20 text-slate-400 flex items-center justify-center hover:text-white transition-colors duration-300"
        aria-label="Tutup tawaran pemasangan aplikasi"
      >
        <X size={12} />
      </button>
    </div>
  );
};
